import browserslist from 'browserslist';
import { createIsbot, isbot } from 'isbot';
import { UAParser } from 'ua-parser-js';
import { useAppStore } from '@stores/app';
import { logError } from './error-tracking';

export const userAgentIsBot = (userAgent = window.navigator.userAgent): boolean => {
	const isIeBot = createIsbot(/MSIE (\d+\.\d+);.*Trident\/(\d+\.\d+)/);
	return checkThirdParty(userAgent) || isbot(userAgent) || isIeBot(userAgent) || checkAzureBot(userAgent);
};

// Covers Chrome versions 1-140
const userAgentIsThirdParty = createIsbot(/Chrome\/(?:1(?:[0-3]\d|40)|[1-9]\d?)\./);

const isOutdatedBrowser = (userAgent: string): boolean => {
	try {
		const parser = new UAParser(userAgent);
		const browser = parser.getBrowser();

		if (browser.name !== 'Chrome') return false;

		const currentVersion = parseInt(browser.version?.split('.')[0] || '0');
		const supportedBrowsers = browserslist('last 4 Chrome versions');
		const minVersion = Math.min(
			...supportedBrowsers.filter((b) => b.startsWith('chrome')).map((b) => parseInt(b.split(' ')[1]))
		);

		return currentVersion < minVersion;
	} catch (error) {
		logError(error as Error);
		return userAgentIsThirdParty(userAgent);
	}
};

export const checkAzureBot = (userAgent = window.navigator.userAgent): boolean => {
	const azureViewportHeight = 960;
	const azureViewportWidth = 1280;
	const isAzureViewport = window.innerWidth === azureViewportWidth && window.innerHeight === azureViewportHeight;
	const azureBot = createIsbot(/(Windows).*Chrome\/(125)/);

	return azureBot(userAgent) && isAzureViewport;
};

export const checkThirdParty = (userAgent = window.navigator.userAgent): boolean => {
	const appStore = useAppStore();
	const thirdPartyViewportHeight = [671, 600];
	const thirdPartyViewportWidth = [800, 1004];
	const thirdPartyRoutes = [
		'/forbidden',
		'/login',
		'/account/overview',
		'/account/portfolio',
		'/account/transactions',
		'/logout-success'
	];
	const route: boolean = thirdPartyRoutes.some((tpRoute) => tpRoute === window.location.pathname);
	const isThirdPartyViewport =
		thirdPartyViewportWidth.includes(window.innerWidth) && thirdPartyViewportHeight.includes(window.innerHeight);
	const isThirdPartyUserAgent = isOutdatedBrowser(userAgent) || (route && isThirdPartyViewport);

	return isThirdPartyUserAgent || appStore.isThirdPartyLogin;
};
